import { render, staticRenderFns } from "./ProfileBiodata.vue?vue&type=template&id=b4b9d1de"
import script from "./ProfileBiodata.vue?vue&type=script&lang=js"
export * from "./ProfileBiodata.vue?vue&type=script&lang=js"
import style0 from "./ProfileBiodata.vue?vue&type=style&index=0&id=b4b9d1de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports